const FAVORITES_KEY = 'etolie_favs';

function countFavoriteEntries(rawItems) {
  if (!Array.isArray(rawItems)) return 0;

  const normalized = rawItems.reduce((items, raw) => {
    const source = typeof raw === 'string' ? { handle: raw } : raw;
    if (!source || typeof source !== 'object') return items;
    const handle = String(source.handle || source.h || '').trim().toLocaleLowerCase('pl-PL');
    if (!handle) return items;
    const color = String(source.color || source.c || '')
      .trim()
      .toLocaleLowerCase('pl-PL')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');
    items.push({ handle, color });
    return items;
  }, []);
  const productLevelHandles = new Set(
    normalized.filter((item) => !item.color).map((item) => item.handle)
  );
  const keys = new Set();

  normalized.forEach((item) => {
    if (productLevelHandles.has(item.handle) && item.color) return;
    keys.add(`${item.handle}::${item.color ? `color:${item.color}` : 'product'}`);
  });
  return keys.size;
}

window.etolieFavoriteCount = countFavoriteEntries;

function readFavoriteCount() {
  if (window.etolieFavs?.get) return window.etolieFavs.get().length;

  try {
    const value = JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
    return countFavoriteEntries(value);
  } catch (_error) {
    return 0;
  }
}

function updateHeaderFavorites(explicitCount) {
  const count = Number.isFinite(Number(explicitCount))
    ? Math.max(0, Number(explicitCount))
    : readFavoriteCount();

  document.querySelectorAll('[data-etolie-header-favorites]').forEach((link) => {
    const dot = link.querySelector('[data-etolie-header-favorites-dot]');
    const label = link.querySelector('[data-etolie-header-favorites-label]');
    if (dot && dot.hidden !== (count === 0)) dot.hidden = count === 0;
    const accessibleLabel = count > 0 ? `${window.etolieT('Ulubione')}: ${count}` : window.etolieT("Ulubione");
    if (label && label.textContent !== accessibleLabel) label.textContent = accessibleLabel;
    if (link.getAttribute('aria-label') !== accessibleLabel) link.setAttribute('aria-label', accessibleLabel);
    if (link.classList.contains('has-favorites') !== (count > 0)) {
      link.classList.toggle('has-favorites', count > 0);
    }
  });
}

function favoriteCountFromStorageValue(value) {
  try {
    return countFavoriteEntries(JSON.parse(value || '[]'));
  } catch (_error) {
    return readFavoriteCount();
  }
}

function dispatchFavoritesSync(count, source) {
  document.dispatchEvent(new CustomEvent('etolie:favs', {
    detail: { count, source },
  }));
}

// Jeden stan „stopka jest na ekranie" dla wszystkich pływających elementów:
// pigułki filtrów i launchera Inbox. Wcześniej pilnował go tylko listing, więc
// na home, w wyszukiwarce i na stronach treści ikona czatu siadała na linkach
// stopki. Warunkiem jest sama stopka, bo to ona jest powodem, a nie szablon.
function initFooterGuard() {
  const footer = document.querySelector('body > footer, footer[role="contentinfo"], footer');
  if (!footer) return;

  const syncFooterState = () => {
    const bounds = footer.getBoundingClientRect();
    const isVisible = bounds.top < window.innerHeight && bounds.bottom > 0;
    document.body.classList.toggle('etolie-footer-visible', isVisible);
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(syncFooterState, { threshold: 0.01 });
    observer.observe(footer);
  } else {
    window.addEventListener('scroll', syncFooterState, { passive: true });
    window.addEventListener('resize', syncFooterState, { passive: true });
  }

  syncFooterState();
}

// Ten sam rejestr stanów, karta produktu (audyt 29.09.2026): na telefonie główny przycisk
// „Wybierz rozmiar / Dodaj do koszyka" przejeżdża przy przewijaniu przez prawy dolny róg,
// a ikona czatu i kafelek hot oferty zasłaniały na nim cenę. Klasy na <html> trwają TYLKO
// wtedy, gdy prostokąty faktycznie na siebie nachodzą (nie przez cały czas widoczności
// przycisku). CSS chowa przez visibility, więc prostokąt zostaje policzalny i nic nie skacze.
function initBuyButtonGuard() {
  if (!document.body.matches('[data-template^="product"]')) return;

  const root = document.documentElement;
  const watched = new Set();
  const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(() => schedule()) : null;
  let chatButton = null;
  let frame = 0;
  let chatLookups = 0;

  const watch = (element) => {
    if (!element || !resizeObserver || watched.has(element)) return;
    watched.add(element);
    // Zmiana rozmiaru 0 ↔ 44 px = inna reguła rejestru pokazała lub schowała element
    // (baner zgody, menu, [hidden] kafelka) bez przewinięcia strony.
    resizeObserver.observe(element);
  };

  const covers = (element, target) => {
    if (!element) return false;
    const bounds = element.getBoundingClientRect();
    if (!bounds.width || !bounds.height) return false;
    return bounds.left < target.right && bounds.right > target.left
      && bounds.top < target.bottom && bounds.bottom > target.top;
  };

  const sync = () => {
    frame = 0;
    if (!chatButton?.isConnected) chatButton = znajdzPrzyciskCzatu();
    // Inbox rysuje przycisk kilka sekund po starcie strony; bez przewinięcia nikt by go nie sprawdził.
    if (!chatButton && chatLookups < 20) {
      chatLookups += 1;
      setTimeout(schedule, 500);
    }
    const hot = document.querySelector('.etolie-hot');
    watch(chatButton);
    watch(hot);

    const button = document.querySelector('.buy-buttons-block [ref="addToCartButton"]');
    const target = button?.getBoundingClientRect();
    const onScreen = Boolean(target && target.height && target.bottom > 0 && target.top < window.innerHeight);
    const chatCovers = onScreen && covers(chatButton, target);
    const hotCovers = onScreen && covers(hot, target);
    if (root.classList.contains('etolie-atc-chat') !== chatCovers) root.classList.toggle('etolie-atc-chat', chatCovers);
    if (root.classList.contains('etolie-atc-hot') !== hotCovers) root.classList.toggle('etolie-atc-hot', hotCovers);
  };

  function schedule() {
    if (!frame) frame = requestAnimationFrame(sync);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  schedule();
}

function initTechnicalProductMedia() {
  if (!document.body.matches('[data-template^="product"]')) return;

  // Liquid owns the "is this a size chart" answer (snippet etolie-media-is-size)
  // and hands it over in data-etolie-size-chart. No second rule and no second
  // regex here: the gallery would otherwise flip to a different answer after
  // variant:update re-renders it.
  const markMedia = (scope = document) => {
    const selector = scope.matches?.('media-gallery')
      ? '.product-media-container'
      : 'media-gallery .product-media-container';
    scope.querySelectorAll(selector).forEach((container) => {
      container.classList.toggle(
        'etolie-product-media--technical',
        container.dataset.etolieSizeChart === 'true'
      );
    });
  };

  markMedia();
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    if (gallery.dataset.etolieTechnicalObserver === 'true') return;
    gallery.dataset.etolieTechnicalObserver = 'true';
    new MutationObserver(() => markMedia(gallery)).observe(gallery, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-etolie-size-chart'],
    });
  });
}

function initHeaderFavorites() {
  updateHeaderFavorites();

  // Cart section responses also replace the header with server HTML, which
  // cannot know local favorites. Keep their indicator in sync after each morph.
  // Observe the stable wrapper so replacing the whole header is covered too.
  const headerGroup = document.getElementById('header-group');
  if (headerGroup) {
    new MutationObserver(() => updateHeaderFavorites()).observe(headerGroup, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label', 'hidden'],
    });
  }

  document.addEventListener('etolie:favs', (event) => {
    updateHeaderFavorites(event.detail?.count);
  });
  window.addEventListener('storage', (event) => {
    if (event.storageArea && event.storageArea !== localStorage) return;
    if (event.key !== FAVORITES_KEY && event.key !== null) return;

    // Cross-tab synchronization is read-only: publish the new state to every
    // control, never call set/toggle in reaction to the storage event. A null
    // key is localStorage.clear(), so every favorite becomes inactive.
    dispatchFavoritesSync(favoriteCountFromStorageValue(event.newValue), 'storage');
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) dispatchFavoritesSync(readFavoriteCount(), 'pageshow');
  });
}

function initLuxuryReveal() {
  const candidates = document.querySelectorAll('[data-etolie-reveal]');
  if (!candidates.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    candidates.forEach((element) => element.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  candidates.forEach((element) => observer.observe(element));
}

function initChatEdgeAnchor() {
  // Inbox po 60 s uruchamia przypomnienie (nudge): translate rodzica przycisku zmienia blok odniesienia
  // naszego position: fixed i odsuwa ikonę 20 px od krawędzi. Od 18.09.2026 ten rodzic siedzi w zagnieżdżonym
  // shadow root shopify-agent-runtime, więc styl wyłączający animację trafia do każdego roota widgetu (15.10.2026).
  customElements.whenDefined('shopify-chat').then(() => {
    const observers = new Map();
    const install = () => {
      const root = document.querySelector('shopify-chat')?.shadowRoot;
      if (!root) return false;
      const roots = new Set();
      const visit = (root) => {
        roots.add(root);
        if (!root.getElementById('etolie-chat-edge-anchor')) {
          const style = document.createElement('style');
          style.id = 'etolie-chat-edge-anchor';
          style.textContent = `
            .activator-nudge.activator-nudge--active {
              animation-name: none;
              translate: none;
            }
          `;
          root.append(style);
        }
        if (!observers.has(root)) {
          const observer = new MutationObserver(install);
          observer.observe(root, { childList: true, subtree: true });
          observers.set(root, observer);
        }
        for (const element of root.querySelectorAll('*')) {
          if (element.shadowRoot) visit(element.shadowRoot);
        }
      };
      visit(root);
      for (const [root, observer] of observers) {
        if (!roots.has(root)) {
          observer.disconnect();
          observers.delete(root);
        }
      }
      return true;
    };

    // An existing runtime element can be upgraded after the outer chat mounts.
    customElements.whenDefined('shopify-agent-runtime').then(install);
    if (install()) return;
    const observer = new MutationObserver(() => {
      if (install()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true });
    // A newly defined custom element can attach its shadow root on first render.
    requestAnimationFrame(() => {
      if (install()) observer.disconnect();
    });
  });
}

// ETOLIE 18.09.2026: Inbox przeniósł przycisk czatu o poziom głębiej (shopify-chat > shopify-agent-runtime),
// więc szukamy go przez wszystkie zagnieżdżone shadow DOM-y, a nie tylko w pierwszym.
function znajdzPrzyciskCzatu() {
  const szukaj = (root) => {
    const tutaj = root.querySelector('[part="activator"], button.activator');
    if (tutaj) return tutaj;
    for (const element of root.querySelectorAll('*')) {
      if (element.shadowRoot) {
        const glebiej = szukaj(element.shadowRoot);
        if (glebiej) return glebiej;
      }
    }
    return null;
  };
  const czat = document.querySelector('shopify-chat');
  return czat?.shadowRoot ? szukaj(czat.shadowRoot) : null;
}

function initChatLinks() {
  // ETOLIE 15.09.2026 (Jarek): link [data-etolie-chat] (np. „Napisz na czacie” w „Pomoc i kontakt” na karcie produktu)
  // otwiera okno Shopify Inbox zamiast poczty: klik w natywny przycisk launchera w otwartym shadow DOM (ten sam element,
  // który stylujemy przez ::part(activator)). Gdy Inbox się nie załadował, link zostaje zwykłym mailto.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-etolie-chat]');
    if (!link) return;
    const czat = document.querySelector('shopify-chat');
    const activator = znajdzPrzyciskCzatu();
    if (!czat || !activator) return;
    event.preventDefault();
    // Klik w link bąbelkuje do dokumentu, a Inbox zamyka na nim swoje okno (także to od zaczepki, która pokazuje się sama).
    // Dlatego czekamy, aż to zamknięcie się wykona, i dopiero wtedy otwieramy czat, tylko jeśli naprawdę jest schowany
    // (bez tego nasze kliknięcie zamykało otwarte okno; test 18.09).
    setTimeout(() => {
      if (!czat.hasAttribute('open')) activator.click();
    }, 250);
  });
}

/*
 * Safari iOS: po schowaniu klawiatury wywołanej polem w szufladzie koszyka (kod rabatowy)
 * okno modalne zostaje przesunięte o wysokość nagłówka, a elementy fixed rysują się nad nim
 * (16.10.2026, symulator iOS 27). Minimalny ruch przewijania po zamknięciu klawiatury
 * wymusza ponowne ułożenie warstwy modalnej. Tylko ekrany dotykowe.
 */
function initCartKeyboardSettle() {
  if (!window.matchMedia('(pointer: coarse)').matches) return;
  document.addEventListener(
    'focusout',
    (event) => {
      const field = event.target;
      if (!(field instanceof Element) || !field.closest('.cart-drawer__dialog[open]')) return;
      if (!field.matches('input, textarea, select')) return;
      setTimeout(() => {
        window.scrollBy(0, 1);
        window.scrollBy(0, -1);
      }, 350);
    },
    true
  );
}

function initLuxury() {
  initHeaderFavorites();
  initCartKeyboardSettle();
  initLuxuryReveal();
  initFooterGuard();
  initBuyButtonGuard();
  initTechnicalProductMedia();
  initChatEdgeAnchor();
  initChatLinks();
}

document.addEventListener('shopify:section:load', (event) => {
  initTechnicalProductMedia(event.target);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLuxury, { once: true });
} else {
  initLuxury();
}
